module.exports = __webpack_public_path__ + "img/soul-19.056bd340.png";